'use client';

// ! DO NOT USE THIS COMPONENT DIRECTLY. USE THE PAGINATED OR INFINITE TABLE COMPONENTS INSTEAD.

import { TableBaseImpl } from './_TableBaseImpl';

export { TableBaseImpl as TableBase } from './_TableBaseImpl';
export type * from './TableBaseImpl.types';

export default TableBaseImpl;
